import dayjs from 'dayjs'
import LocalizedFormat from 'dayjs/plugin/localizedFormat'
import utc from 'dayjs/plugin/utc'

dayjs.extend(LocalizedFormat)
dayjs.extend(utc)

export function formatDate(date: string | Date | number, opts?: { format?: string; fallback?: string; utc?: boolean }) {
  const { format = 'lll', fallback, utc: useUtc = false } = opts ?? {}

  let dateMoment = dayjs(date)

  if (useUtc) {
    dateMoment = dayjs.utc(date)
  }

  if (!date || !dateMoment.isValid()) return fallback ?? null

  return dateMoment.format(format)
}
